import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import './index.css';
import isEqual from 'react-fast-compare';
import { Transition } from 'react-transition-group';

class DeliveryAreas extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showEnterAnimation: true,
      showAnimation: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.openDelivery) {
      this.setState({ showEnterAnimation: true, showAnimation: false });
      setTimeout(() => {
        this.setState({ showEnterAnimation: false });
      }, 500);
    }
  }

  showAnimationBeforeClose = () => {
    this.setState(
      {
        showAnimation: true,
      },
      () => {
        setTimeout(() => {
          this.props.closeDelivery();
        }, 300);
      }
    );
  };

  shouldComponentUpdate(nextProps, nextState) {
    return !(isEqual(this.props, nextProps) && isEqual(this.state, nextState));
  }

  render() {
    const { storeConfig, open, close } = this.props;

    const transitionStyles = {
      entering: { transform: `translateX(100%)` },
      entered: { transform: `translateX(0)` },
      exiting: { transform: `translateX(100%)` },
      exited: { transform: `translateX(100%)`, display: `none` },
    };

    return (
      <Transition timeout={250} mountOnEnter unmountOnExit in={open}>
        {(state) => (
          <div
            className='openHWrap'
            id='delivery-areas'
            style={{
              zIndex: 10000,
              position: `absolute`,
              width: `100%`,
              height: `100%`,
              background: `white`,
              top: 0,
              left: 0,
              right: 0,
              transition: `transform .25s ease-out`,
              ...transitionStyles[state],
            }}
          >
            <div
              className='backToOrder thickcon-Left-Chevron'
              onClick={close}
            />
            <div className='detailsTitle oH' style={{ marginTop: 0 }}>
              Delivery Areas
            </div>
            <ul>
              {this.props.allSuburbs &&
                this.props.allSuburbs.map((item, index) => (
                  <li key={index}>
                    {item.name}
                    <span>
                      {storeConfig.currency} {item.deliveryCost}
                    </span>
                  </li>
                ))}
            </ul>
          </div>
        )}
      </Transition>
    );
  }
}

DeliveryAreas.propTypes = {
  allSuburbs: PropTypes.any,
  openDelivery: PropTypes.any,
  closeDelivery: PropTypes.any,
};

function mapStateToProps(state) {
  return {
    allSuburbs: state.orderReducer.allSuburbs,
    storeConfig: state.layoutReducer.storeConfig,
  };
}

export default connect(mapStateToProps)(DeliveryAreas);
